// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0

import React from 'react';

const GalleryLayout: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fillRule="evenodd" fill="currentColor">
      <g>
        <path d="M17.84 13c.64 0 1.16.789 1.16 1.759v2.48c0 .97-.52 1.761-1.16 1.761h-3.68c-.64 0-1.16-.79-1.16-1.76v-2.481c0-.97.52-1.759 1.16-1.759zm-8 0c.64 0 1.16.789 1.16 1.759v2.48C11 18.21 10.48 19 9.84 19H6.16C5.52 19 5 18.21 5 17.24v-2.481C5 13.789 5.52 13 6.16 13zm7.9 1h-3.48c-.143 0-.26.227-.26.502v2.994c0 .275.117.504.26.504h3.48c.144 0 .26-.229.26-.504v-2.994c0-.275-.116-.502-.26-.502zm-8 0H6.26c-.143 0-.26.227-.26.502v2.994c0 .275.117.504.26.504h3.48c.144 0 .26-.229.26-.504v-2.994c0-.275-.116-.502-.26-.502zm8.1-9c.64 0 1.16.789 1.16 1.759v2.48c0 .97-.52 1.761-1.16 1.761h-3.68c-.64 0-1.16-.79-1.16-1.76V6.759C13 5.789 13.52 5 14.16 5zm-8 0c.64 0 1.16.789 1.16 1.759v2.48C11 10.21 10.48 11 9.84 11H6.16C5.52 11 5 10.21 5 9.24V6.759C5 5.789 5.52 5 6.16 5zm7.9 1h-3.48c-.143 0-.26.227-.26.502v2.994c0 .275.117.504.26.504h3.48c.144 0 .26-.229.26-.504V6.502c0-.275-.116-.502-.26-.502zm-8 0H6.26c-.143 0-.26.227-.26.502v2.994c0 .275.117.504.26.504h3.48c.144 0 .26-.229.26-.504V6.502C10 6.227 9.884 6 9.74 6z" />
      </g>
    </g>
  </svg>
);

export default GalleryLayout;
